import { render, staticRenderFns } from "./UsersList.vue?vue&type=template&id=074a085a"
import script from "@/scripts/users/usersList.js?vue&type=script&lang=js&external"
export * from "@/scripts/users/usersList.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports